<template>
  <div>
    <div class="container-md">
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-between">
            <h3 class="text-uppercase">
              {{ item.title }}
            </h3>
            <div v-if="userCanEdit">
              <i
                class="btn btn-dark btn-sm fa"
                :class="[editMode ? 'fa-window-close' : 'fa-edit']"
                @click="editMode = !editMode"
              ></i>
            </div>
          </div>

          <div v-html="item.description"></div>
        </div>

        <div class="col-12" v-if="itemgroups.length > 0">
          <div class="container-bg pb-2">
            <div class="text-center">
              <h3 class="text-uppercase d-block">Hoort bij:</h3>
            </div>
            <div class="text-center">
              <a
                :href="
                  '/itemgroups/' + itemgroup.id + '/' + itemgroup.title_slug
                "
                class="btn open-btn btn-primary bg-dark mr-3"
                v-for="(itemgroup, index) in itemgroups"
                :key="'itemgroupOpenBtn_' + index"
              >
                {{ itemgroup.title }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="media_loaded">
        <div
          class="col-12 mt-3"
          v-for="(structure, index) in item.itemtype.structure"
          :key="'structure_' + index"
        >
          <div class="container-bg p-3">
            <div class="d-flex justify-content-between">
              <h3 class="text-uppercase">{{ structure.title }}</h3>
            </div>
            <!-- Structure field start -->
            <div
              class="col-12"
              v-for="(field, fieldIndex) in structure.fields"
              :key="'fieldIndex_' + fieldIndex"
            >
              <div class="d-flex">
                <h3 v-if="structure.fields.length > 0" class="mr-3">
                  {{ field.label }}
                </h3>
                <a
                  v-if="structure.multiple && editMode && editableByUser(structure)"
                  @click="toggleItemValue(index, fieldIndex, null, 'add')"
                  class="mt-2"
                  style="color:green;font-size:14px"
                >
                  <i class="fas fa-plus"></i>
                </a>
              </div>
              <div
                v-for="(value, vIndex) in field.values"
                :key="vIndex"
                class=""
              >
                <a
                  v-if="
                    editMode && editableByUser(structure) &&
                      value[1] != undefined &&
                      (canEditItem ||
                        structure.members.some((id) => id == user.id))
                  "
                  href="javascript:void(0)"
                  @click="toggleItemValue(index, fieldIndex, vIndex, 'delete')"
                  class="mt-2 ml-2"
                  style="color:red;font-size:14px"
                >
                  <i class="fas fa-times"></i> Onderdeel verwijderen
                </a>
                <div v-if="field.field == 'tinymce'">
                  <editor
                    v-if="editMode && editableByUser(structure)"
                    v-model="value[1]"
                    :init="{
                      height: 200,
                      menubar: false,
                      language: 'nl',
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
                                                            alignleft aligncenter alignright alignjustify | \
                                                            bullist numlist outdent indent | removeformat | help',
                    }"
                  />
                  <p v-else v-html="value[1]"></p>
                </div>
                <p v-else-if="field.field == 'text'">
                  <input
                    v-if="editMode && editableByUser(structure)"
                    type="text"
                    class="form-control mb-2"
                    v-model="value[1]"
                  />

                  <span v-else>{{ value[1] }}</span>
                </p>
                <div v-else-if="field.field == 'youtube_url'">
                  <input
                    v-if="editMode && editableByUser(structure)"
                    type="text"
                    class="form-control mb-2"
                    v-model="value[1]"
                  />
                  <iframe
                    v-else
                    width="100%"
                    height="400px"
                    :src="value[1]"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
                <div v-else-if="field.field == 'url'">
                  <input
                    v-if="editMode && editableByUser(structure)"
                    type="text"
                    class="form-control mb-2"
                    v-model="value[1]"
                  />
                  <a v-else :href="value[1]" target="_blank">{{ value[1] }}</a>
                </div>
                <div v-else-if="field.field == 'file'">
                  <span v-html="getFileName(value)"></span>

                  <div
                    v-if="
                      editMode && editableByUser(structure) &&
                        (canEditItem ||
                          structure.members.some((id) => id == user.id))
                    "
                    class="d-flex mt-3"
                  >
                    <button class="btn btn-dark mr-3 p-0">
                      <label
                        :for="
                          'file-uploader' +
                            '' +
                            index +
                            '' +
                            fieldIndex +
                            '' +
                            vIndex
                        "
                        class="m-0 pt-1 pb-1 pl-2 pr-2"
                      >
                        Wijzigen</label
                      >
                    </button>

                    <input
                      type="file"
                      :id="
                        'file-uploader' +
                          '' +
                          index +
                          '' +
                          fieldIndex +
                          '' +
                          vIndex
                      "
                      class="form-control mb-2 d-none"
                      @change="newFile($event, index, fieldIndex, vIndex)"
                    />
                  </div>
                </div>
                <div v-else>Niet ingevuld...</div>
              </div>
            </div>
            <!-- Structure field end -->
          </div>
        </div>
      </div>

      <div class="row mt-3 ml-1">
        <button
          @click="editMedia"
          :disabled="saving"
          v-if="editMode"
          class="btn-dark"
          style="margin-bottom:100px"
        >
          {{ !saving ? "Opslaan" : "Bezig met opslaan..." }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "../../../mixins/index";
export default {
  data() {
    return {
      item: {
        itemtype: {
          structure: false,
        },
        values: false,
      },
      itemgroups: [],
      media: [],
      media_loaded: false,
      edit_structure: {},
      userCanEdit: false,
      editMode: false,
      saving: false,
      deletedItemValues: [],
    };
  },
  computed: {
    canEditItem() {
      return this.userHasRoles(["Super-admin"]);
    },
    user() {
      return this.$store.state.auth.user;
    },
  },
  mixins: [mixins],
  async created() {
    await this.$store
      .dispatch("get", "api/v1/items/" + this.$route.params.id)
      .then((data) => {
        console.log(data);
        this.item = data.data.data;
        this.compute();

        this.$store.state.breadcrumbs = {
          title: "Informatie",
          links: [
            {
              title: "Informatie",
              href: "/itemgroups",
            },
            {
              title: this.$route.params.title,
              href: `/items/${this.$route.params.id}/${this.$route.params.title}`,
            },
          ],
        };
        // this.committees = this.itemgroup.committees
      })
      .catch((error) => {
        console.log(error);
      });

    this.$store
      .dispatch("get", "api/v1/items/" + this.$route.params.id + "/itemgroups")
      .then((data) => {
        this.itemgroups = data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.$store
      .dispatch("get", "api/v1/items/" + this.$route.params.id + "/media")
      .then((data) => {
        console.log("media", data);
        this.media_loaded = true;
        this.media = Array.isArray(data.data) ? {} : data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    //Redundant code
    this.$store
      .dispatch("post", {
        endpoint: "api/v1/item/check-creation",
        details: {
          user_id: this.$store.state.auth.user.id,
          itemtype_id: this.item.itemtype.id,
        },
      })
      .then((data) => {
        console.log(data.data);
      });

    if (this.userHasRoles(["Super-Admin", "Admin"])) {
      this.userCanEdit = true;
    }
  },
  methods: {
    editableByUser(structure){

      if(this.userHasRoles(["Super-Admin", "Admin"])){
        return true;
      }
      
      if(this.user.committees){
        if(this.user.committees.some(r => structure.committees.includes(r))){
          return true;
        }
      }

      if(structure.members){
        if(structure.members.includes(this.user.id)){
          return true;
        }
      }
      
      return false;
    },
    compute() {
      if (!this.item.itemtype.structure || !this.item.values) {
        return false;
      }
      let values = {};
      this.item.itemtype.structure = this.item.itemtype.structure.map((row) => {
        // console.log("ROW", row);
        if (!Object.prototype.hasOwnProperty.call(values, row.group_id)) {
          values[row.group_id] = {};
        }
        row.fields = row.fields.map((field) => {
          console.log("FIELD", field.label, field.field_id, row.multiple);
          if (
            !Object.prototype.hasOwnProperty.call(
              values[row.group_id],
              field.field_id
            )
          ) {
            values[row.group_id][field.field_id] = [];
          }

          if (!Object.prototype.hasOwnProperty.call(field, "values")) {
            field["values"] = [];
          }

          if (
            Object.prototype.hasOwnProperty.call(this.item.values, row.group_id)
          ) {
            if (
              Object.prototype.hasOwnProperty.call(
                this.item.values[row.group_id],
                field.field_id
              )
            ) {
              for (var i in this.item.values[row.group_id][field.field_id]) {
                console.log(">>>", i);
                field["values"].push({
                  0: this.item.values[row.group_id][field.field_id][i]["id"],
                  1: this.item.values[row.group_id][field.field_id][i]["value"],
                });
              }
            }
          }

          if (field["values"] == undefined || field["values"].length == 0) {
            field["values"] = [{ "0": null, "1": "" }];
          }
          console.log(field);
          return field;
        });
        return row;
      });
    },
    toggleItemValue(index, fieldIndex, vIndex, action) {
      var structures = [...this.item.itemtype.structure];
      var selectedStructure = { ...structures[index] };

      console.log(structures);
      if (action == "add") {
        if (selectedStructure.fields.length > 0) {
          selectedStructure.fields[fieldIndex].values.push({
            "0": null,
            "1": "",
          });
          this.editMode = true;
        }
      } else {
        if (selectedStructure.fields.length > 0) {
          console.log(vIndex);
          this.deletedItemValues.push(
            selectedStructure.fields[fieldIndex].values[vIndex][0]
          );
          selectedStructure.fields[fieldIndex].values.splice(vIndex, 1);
        }
      }

      structures[index] = { ...selectedStructure };
      this.item.itemtype.structure = structures;
      console.log(structures);
    },
    newFile(e, index, fileIndex, n) {
      var fileReader = new FileReader();
      fileReader.onload = (result) => {
        var structures = this.item.itemtype.structure;
        structures[index].fields[fileIndex].values[n][1] = result.target.result;
        structures[index].fields[fileIndex].values[n]["file_name"] =
          e.srcElement.files[0].name;
        this.item.itemtype.structure = [...structures];
        console.log(index, fileIndex, n);
      };
      fileReader.readAsDataURL(e.srcElement.files[0]);
    },
    removeField(index, fileIndex, n) {
      var temp = this.item.itemtype.structure;
      temp[index].fields[fileIndex].values[n][1] = null;
      this.item.itemtype.structure = [...temp];
    },
    getFileLink(file_id) {
      if (!Object.prototype.hasOwnProperty.call(this.media, file_id)) {
        return false;
      } else {
        if (this.media[file_id].custom_properties.public) {
          return this.media[file_id].original_url;
        }
        return false;
      }
    },
    getFileName(file) {
      console.log(file);
      if (!Object.prototype.hasOwnProperty.call(this.media, file[1])) {
        if (file["file_name"] != undefined) {
          return file["file_name"];
        }
        return "";
      } else {
        var media = this.media[file[1]];
        return (
          "<a href='" +
          media.original_url +
          "' target='_blank'>" +
          media.original_url +
          "</a>"
        );
      }
    },
    editMedia() {
      this.saving = true;
      var fields_values = [];
      this.item.itemtype.structure.forEach((infoG) => {
        infoG.fields.forEach((field) => {
          field.values.forEach((v) => {
            fields_values.push({
              itemvalue_id: v[0],
              group_id: infoG.group_id,
              field_id:
                field.field_id != undefined
                  ? field.field_id
                  : Math.random() * 99,
              label: field.label,
              value: v[1],
              shouldDelete: v[1] != null ? false : true,
              field: field.field,
            });
          });
        });
      });

      var item = {
        title: this.item.title,
        body: this.item.description,
        active: this.item.active,
        public: this.item.public,
        itemtype_id: this.item.itemtype.id,
        fields_values: fields_values,
        deletedItemValues: this.deletedItemValues,
      };

      console.log(item);

      this.$store
        .dispatch("put", {
          endpoint: "api/v1/items/" + this.item.id,
          details: item,
        })
        .then(() => {
          this.$store.dispatch("auth/makeNotification", {
            status: "Item",
            statusText: "Item succesvol bijgewerkt",
          });
          window.location.reload();
        })
        .catch(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  margin-top: 10px;
  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  margin-right: 10px;
  padding: 10px 0;
  width: auto;
}
.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  padding: 0;
  border: unset;
}

.no-gutters {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.card-footer {
  border-top: unset;
}
</style>
